/* globals Class, $H,  jui, lp */
var _ = require('lodash');
var ubBanzai = require('ub/control/banzai-features');
var isSandboxMode = ubBanzai.features.isSandboxEnabled();

var rxUi = window.rxUi;

var svgIcons = {
  'lp-script':'svg-ico-javascript',
  'lp-stylesheet':'svg-ico-stylesheet'
};

lp.editor.NonVisibleElementsShelf = Class.create(jui.Component, {
  options: function($super,options){
    return $super($H({attributes:{id:'non-visible-elements-shelf', className: 'footer-controls'}}).merge(options));
  },

  initialize: function($super, editor, options) {
    //TODO: revisit this routingKey:
    this._uiBinding = new rxUi.Binding('NonVisibleElementsShelf');
    $super(options);
    this.editor = editor;

    editor.addListener('activeRootChanged', this);
    editor.addListener('elementInserted', this);
    editor.addListener('elementRemoved', this);
    editor.addListener('updateWarning', this);
    this.invisibles = {};
  },

  installUI: function($super) {
    $super();
    this.shelf = this.insert(new jui.Component({attributes: {className: 'shelf footer-control custom-scripts'}}));
    var domainEventType = 'openModalBuilder';
    this._uiBinding.sink
      .filter(function(ev) {
        return ev.type === domainEventType;
      })
      .ub_subscribe(function(ev) {
        var elm = ev.elementId ? self.editor.page.getElementById(ev.elementId) : null;
        lp.getModule(ev.elementType).openBuilder(elm);
      });
    var self = this;

    this._triggerOpenBuilder = function(elementType, elementId) {
      if (isSandboxMode) { return; }

      self._uiBinding.source.onNext({type: domainEventType,
                                     elementType: elementType,
                                     elementId: elementId});
    };

    _.bind(this._triggerOpenBuilder);
  },

  activeRootChanged: function() {
    this.updateShelf();
  },

  elementInserted: function() {
    this.updateShelf();
  },

  elementRemoved: function() {
    this.updateShelf();
  },

  makeZeroElementButton: function(type) {
    var module = lp.getModule(type);
    var self = this;

    var button = new jui.Button({
      label: module.name + (module.getLimit() === 1 ? '' : 's'),
      elementType:'span',
      attributes: {className: 'footer-control-button shelf-button ' + type + ' ' + svgIcons[type]},
      action: function() {
          self._triggerOpenBuilder(type, null);
        }
    });

    button.insert(new Element('div', {className: 'add'}));
    this.shelf.insert(button);
  },

  makeSingleElementButton: function(elm, type) {
    var self = this;
    var button = new jui.Button({
      label: elm.name,
      attributes: {className: 'footer-control-button shelf-button '+ type + ' ' + svgIcons[type]},
      action: function() {
          self._triggerOpenBuilder(type, elm.id);
      }});
    this.shelf.insert(button);
  },

  makeMultiElementButton: function(elms, type) {
    var module = lp.getModule(type);
    var self = this;
    var menuItems = elms.collect( function(elm) {
      var model = elm.model;
      var hasError = model.exists('content.valid') && !model.get('content.valid');
      var errorClass = hasError  ? 'error' : '';
      var el = "<span class='menu-label " + errorClass + "'>" + elm.name + '</span>';
      if (hasError) {
        el += ' <span class="invalid svg-ico-warning4"></span>';
      }
      return {type:'item', label:el, tag:elm, data:elm, warning: hasError};
    });

    var addNewLabel = '+ ';

    menuItems.push({type:'item', label: addNewLabel + 'Add New '+module.name});
    var button = new jui.PopUpButton(
      new jui.Menu({
        items: menuItems,
        attributes: {className: 'menu scrollable shelf'},
        action:function(e) {
          var elm = e.data.selectedItem.data;
          self._triggerOpenBuilder(type, elm ? elm.id: null);
        }
      }),
      {
        label: module.name + 's',
        elementType:'span',
        above: true,
        attributes: {className: 'footer-control-button shelf-button multi '+ type + ' ' + svgIcons[type]}
      }
    );

    var validElements = elms.find(function(e){
      return e.model.exists('content.valid') && e.model.get('content.valid') === false;
    });

    var errorCountCls = validElements ? 'count-error' : '';
    button.insert(new Element('div', {className: 'footer-control-button-count count ' + errorCountCls}).update(elms.length));
    this.shelf.insert(button);
  },

  elementAllowed: function (type) {
    switch(type){
      case 'lp-script': return this.editor.page.getConfigValue('allowCustomScripts');
      case 'lp-stylesheet': return this.editor.page.getConfigValue('allowCustomStyles');
    }
  },

  elementAttributeChanged: function(e) {
    if (e.data.accessor === 'name') {
      this.updateShelf();
    }
  },

  makeElementButtons: function (elms, type) {
    if (elms.length === 0 || isSandboxMode) {
      this.makeZeroElementButton(type);
    } else {
      this.makeMultiElementButton(elms, type);
    }
  },

  getButtonGroup: function (groups) {
    var type;
    for (type in groups) {
      var isAllowed = this.elementAllowed(type);
      var elms = groups[type];

      if(isAllowed){
        this.makeElementButtons(elms, type);
      }
    }
  },

  updateShelf: function() {
    this.shelf.clear();
    // Can't use es6 here. Won't compile and jasmine throws errors.
    var groups = {
      'lp-script': []
    };

    // var groups = [{type:'lp-script', elements:[]}];
    // JS: create groups by module type

    lp.getModulesWithUsageType('non-visible-page-widget').each( function(module) {
      groups[module.type] = this.editor.page.getElementsByType(module.type).findAll( function(elm) {
        elm.model.addListener('attributeChanged', this.elementAttributeChanged.bind(this));
        return !elm.exists('predefined') || !elm.get('predefined');
      }, this);
    }, this);

    this.getButtonGroup(groups);
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/non_visible_elements_shelf.js
// module id = 1007
// module chunks = 0